import React, { useState } from 'react';
import { Container, Accordion as SemanticAccordion } from 'semantic-ui-react';
import InlineSvg from './InlineSvg';
import { replaceUrls } from '../helpers/common';
import { toSnakeCase } from '../helpers/common';
import Link from './Link';
import classNames from 'classnames';

const Accordion = (props) => {
  const { module } = props;
  const { anchorTagLinkText, title, subtitle, introContent, accordion, defaultNoneOpen, accordionWidth } = module;

  // Set initial active index based on defaultNoneOpen prop
  const [activeIndex, setActiveIndex] = useState(defaultNoneOpen ? -1 : 0);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (!e.target.classList.contains('active')) {
        e.target.ariaExpanded = true;
        e.target.classList.add('active');
        e.target.nextElementSibling.classList.add('active');
        e.target.nextElementSibling.ariaHidden = false;
      } else {
        e.target.ariaExpanded = false;
        e.target.classList.remove('active');
        e.target.nextElementSibling.classList.remove('active');
        e.target.nextElementSibling.ariaHidden = true;
      }
    }
  };

  return (
    <section id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container>
        <div className="grid-wrapper">
          <div
            className={classNames('accordions__wrapper', {
              'accordions__wrapper--wide': accordionWidth,
            })}
          >
            {title && <h2 className="accordions__title-h2">{title}</h2>}
            {subtitle && <h3 className="accordions__title-h3">{subtitle}</h3>}
            {introContent && (
              <p className="accordions__body-text">{introContent}</p>
            )}
            <SemanticAccordion data-testid="accordions" className="accordions">
              {(accordion || []).map((accordion, key) => {
                const active = activeIndex === key;
                return (
                  <React.Fragment key={key}>
                    <SemanticAccordion.Title
                      active={active}
                      index={key}
                      onClick={handleClick}
                      onKeyDown={handleKeyPress}
                      aria-label="activate to expand accordion"
                      aria-expanded={active ? 'true' : 'false'}
                      role="button"
                      tabIndex="0"
                    >
                      <h3 className="accordion__title-trigger-text">{accordion.title}</h3>
                      <div className="accordion-plus">
                        <InlineSvg
                          className="accordion-plus accordions__icon"
                          name={'accordion-plus'}
                          color={'blue-3'}
                        />
                      </div>
                      <div className="accordion-minus">
                        <InlineSvg
                          className="accordion-minus accordions__icon"
                          name={'accordion-minus'}
                          color={'red-2'}
                        />
                      </div>
                    </SemanticAccordion.Title>
                    <SemanticAccordion.Content
                      active={active}
                      aria-hidden={active ? 'false' : 'true'}
                    >
                      <div
                        className="accordions__content"
                        role="region"
                        tabIndex={active ? 0 : -1}
                        dangerouslySetInnerHTML={{
                          __html: replaceUrls(accordion.content),
                        }}
                      ></div>
                      {accordion?.ctaButton?.ctaButtonText ? (
                        <Link
                          to={accordion?.ctaButton?.ctaButtonDestinationLink?.url}
                          className="button button--outline accordions__cta--button"
                        >
                          {accordion.ctaButton.ctaButtonText}
                        </Link>
                      ) : null}
                    </SemanticAccordion.Content>
                  </React.Fragment>
                );
              })}
            </SemanticAccordion>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Accordion;
